import { useHashBasedHistory, Router, toUrl } from '@yl/react-router'
import { createContext } from 'preact'
import { useContext } from 'preact/hooks'

export type HistoryType = 'HTML5' | 'HASH'

export function createRoutes(baseUrl?: string, type: HistoryType = 'HTML5') {
  type === 'HASH' && useHashBasedHistory()
  return new Router(
    {
      home: toUrl('/home'),
    },
    baseUrl || ''
  ).start()
}

export type Routes = ReturnType<typeof createRoutes>

export const RoutesContext = createContext<Routes | undefined>(undefined)

export function useRoutes(): Routes {
  return useContext(RoutesContext)!
}
